/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IProblemReasons } from '../../entities/PaymentsStatus/ProblemReasons';

export type TGetPaymentsStatusModel = IModel<IGetPaymentsStatusRequest, TGetPaymentsStatusResponse>;

export interface IGetPaymentsStatusRequest {
  paymentProvider?: EPaymentProvider | null;
}

export type TGetPaymentsStatusResponse = IGetPaymentsStatusResponse200 | IGetPaymentsStatusResponse400;

export interface IGetPaymentsStatusResponse200 extends IModelResponse<IGetPaymentsStatusResponse> {
  statusCode: 200;
}

export interface IGetPaymentsStatusResponse400 extends IModelResponse<IGetPaymentsStatusResponseError> {
  statusCode: 400;
}

export interface IGetPaymentsStatusResponse {
  /** Общее состояние флоу платежей в системе **/
  status?: EStatus | null;
  problemReasons?: IProblemReasons | null;
}

export interface IGetPaymentsStatusResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetPaymentsStatusResponse | IGetPaymentsStatusResponseError;

export enum EStatus {
  /** Всё хорошо **/
  Ok = 'ok',
  /** Ситуация нестабильна **/
  Unstable = 'unstable',
}

export enum EPaymentProvider {
  /** undefined **/
  Unknown = 'unknown',
  /** undefined **/
  YooKassa = 'yooKassa',
  /** undefined **/
  CloudPayments = 'cloudPayments',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetPaymentsStatusResponse): TResponse200;
  400(response: IGetPaymentsStatusResponseError): TResponse400;
}
